import React from 'react'
import DatePicker from '../../components/dashboard/datePicker'
import LineChart from '../../components/dashboard/lineChart'
import DoughnutChart from '../../components/dashboard/doughnutChart'
import RoundProgressBar from '../../components/dashboard/progressBar'
import HorizontalCircles from '../../components/dashboard/circles'
import { useAuth } from '../../context/auth-context'


export default function Dashboard() {
    const auth = useAuth()
  return (
    <div>

        <div className='grid grid-cols-3 gap-4'>
            <div className='col-span-2'>
                <div className='bg-yellow-500 rounded-lg p-16'>
                    Hi, {auth.user?.email}
                    <br/>
                    <span className='font-semibold text-lg'>Gold : $84</span>

                </div>

                <hr className='my-5 opacity-0' />
                <h3 className='text-lg font-semibold'>Minerals Transferred</h3>

                

                <div className='border rounded-lg flex p-2 h-[100px] justify-between my-5 '>
                    <div className='grid grid-cols-2 mt-2'>
                    <RoundProgressBar color='#FFD700' percentage={66}/>
                    <span className='text-gray-500 ml-2 mt-2'>
                        Gold 
                        <br />
                        200g
                    </span>
                    </div>
                    <div className='flex items-center'>
                        <HorizontalCircles/> 
                        <span className='bg-gray-500 text-black m-5 p-1 rounded text-white'>In transit</span>
                    </div>
                </div>

                <div className='border rounded-lg flex p-2 h-[100px] justify-between my-5'>
                    <div className='grid grid-cols-2 mt-2'>
                    <RoundProgressBar color='#B87333' percentage={80}/>
                    <span className='text-gray-500 ml-2 mt-2'>
                        Copper 
                        <br />
                        400g
                    </span>
                    </div>
                    <div className='flex items-center'>
                        <HorizontalCircles/> 
                        <span className='bg-gray-500 text-black m-5 p-1 rounded text-white'>In transit</span>
                    </div>
                </div>

                <div className='border rounded-lg flex p-2 h-[100px] justify-between my-5'>
                    <div className='grid grid-cols-2 mt-2'>
                    <RoundProgressBar color='#9966CC' percentage={54}/>
                    <span className='text-gray-500 ml-2 mt-2'>
                    Amethyst
                        <br />
                        350g
                    </span>
                    </div>
                    <div className='flex items-center'>
                        <HorizontalCircles/> 
                        <span className='bg-gray-500 text-black m-5 p-1 rounded text-white'>In transit</span>
                    </div>
                </div>


                <hr className='my-5' />

                <div className='grid grid-cols-3 gap-4'>
                    <div className='col-span-2'>
                    <h3 className='text-lg font-semibold'>Minerals Transferred</h3>
                    <LineChart/>
                    </div>


                    <div>
                    <h3 className='text-lg font-semibold'>Minerals Paid For</h3>
                    <DoughnutChart/>
                    </div>

                </div>

                
            </div>


            <div className='bg-white border border-yellow-500 rounded-lg'>

            <DatePicker/>

            <div className='p-4'>
            <span className='text-lg font-semibold'>Activity</span>

            <div className='rounded-2xl bg-gray-300 p-2 grid grid-cols-4 gap-4 items-center'>

                <div className='rounded-full w-10 h-10 bg-blue-500 text-white flex justify-center items-center'>
                    OC
                </div>

                <div className='col-span-3'>
                    <span className='font-semibold'>Malumbo received gold mineral stock</span>
                    <br />
                    <span className='text-gray-500'>10 April, 2024 | 04:00 PM</span>
                </div>

            </div>


            </div>

           
            </div>

        </div>

    </div>
  )
}
